module.exports = __webpack_public_path__ + "static/media/branding-img28.6fe5ef93.jpg";